import { ApiResponse } from './api-response.models';

export interface Notification {
  id: number;
  type: string;
  description: string;
  isAdminOnly: boolean;
  thresholdDays: number;
  inApp: boolean;
  inEmail: boolean;
  timestamp?: Date;
  isRead?: boolean;
  createdDate?: string;
  message: string;
  notificationType: string;
  isBroadcast: boolean;
}

export type NotificationResponse = ApiResponse<Notification[]>;

export enum NotificationFilterType {
  All = 0,
  Unread = 1,
  Read = 2,
}

export interface NotificationPreference {
  notificationTypeId: number;
  organizationId?: number;
  userId: number;
  inApp: boolean;
  inEmail: boolean;
  thresholdDays?: number;
}

export interface UpdateIsReadFlagRequest {
  notificationId: number;
  isRead: boolean;
  isBroadcast: boolean;
  isDeleted: boolean;
}

export interface UpdateThresholdDaysRequest {
  notificationTypeId: number;
  thresholdDays: number;
}

export const iconTypeMap: Record<string, string> = {
  'new-case-created': 'create',
  'New Case Created': 'create',
  'user-login-reminder': 'deactivate',
  'low-feedback-score': 'deactivate',
  'User Inactivity Alert': 'deactivate',
  'Case Feedback Alert': 'deactivate',
  'data-collection-reminder': 'help',
  'subscription-end-reminder': 'help',
  'Data Collection Reminder': 'help',
  'Subscription Expiry Reminder': 'help',
};
